/*
 *
 * UpfrontTdrDetails reducer
 *
 */
import produce from 'immer';
import moment from 'moment';
import {
  DEFAULT_PG_MENU_TAB_STATE,
  DEFAULT_CURRENT_PAGE,
} from 'utils/constants';
import {
  DEFAULT_ACTION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  UPDATE_FILTERS,
  RESET_FILTERS,
  RESET_PAGE,
  ALL_TIME_DATE_FILTER,
  START_DATE_PAYLOAD,
} from './constants';

const getDefaultFilterState = () => ({
  filters: {
    ...DEFAULT_PG_MENU_TAB_STATE.filters,
    dateFilters: { ...ALL_TIME_DATE_FILTER },
    appliedFilters: {
      startDate: moment(START_DATE_PAYLOAD)
        .startOf('day')
        .format('YYYY-MM-DD 00:00:00'),
      endDate: moment()
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss')
    },
  },
  filtersForDisplay: [],
});

export const initialState = {
  isLoading: false,
  ...getDefaultFilterState(),
};

/* eslint-disable default-case, no-param-reassign */
const upfrontTdrDetailsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case UPDATE_FILTERS: {
        const {
          dateFilters,
          appliedFilters = {},
          filtersForDisplay = [],
          ...filters
        } = action.data;

        if (appliedFilters) draft.filters.appliedFilters = appliedFilters;
        if (dateFilters) draft.filters.dateFilters = dateFilters;

        draft.filters = {
          ...draft.filters,
          ...filters,
        };

        if (filtersForDisplay) draft.filtersForDisplay = filtersForDisplay;
        break;
      }
      case RESET_FILTERS: {
        const { filters, filtersForDisplay } = getDefaultFilterState();
        draft.filters = filters;
        draft.filtersForDisplay = filtersForDisplay;
        break;
      }
      case RESET_PAGE: {
        draft.filters.pageNo = DEFAULT_CURRENT_PAGE;
        // draft.filters.pageNavigation = 0;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default upfrontTdrDetailsReducer;
